import { render, staticRenderFns } from "./MarketplaceTemplates.vue?vue&type=template&id=074011b2&"
import script from "./MarketplaceTemplates.vue?vue&type=script&lang=js&"
export * from "./MarketplaceTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports